import React, { Component } from 'react';
import Button from '../Part_Sample/Button';
import Select from '../Part_Sample/Select';

export default class Select_Language extends Component {
	constructor(props) {
		super(props);

		//Retrieve selected language from local storage
		let lang = 'EN';
		if (window.localStorage.getItem('language') != null) lang = window.localStorage.getItem('language');
		this.props.receiver.setLanguage({ 'lang': lang });

		this.state = {
			lang: lang,
		}
	}

	handleNext = () => {
		let lang = this.state.lang;
		this.props.receiver.setLanguage({ 'lang': lang });
		window.localStorage.setItem('language', lang);
		this.props.content_handler('Terms_and_Conditions');
	}

	handleChangeLanguage = (lang) => {
		let language_list = this.props.receiver.getLanguageList();
		for (let i in language_list) {
			if (language_list[i].value == lang) {
				this.setState({
					lang: lang
				})

				// Set language upon selection
				this.props.receiver.setLanguage({ 'lang': lang });
			}
		}
	}

	render() {
		let list = this.props.receiver.getLanguageList();
		let languages = [];

		for (let i = 0; i < list.length; i++) {
			languages.push(<option value={list[i].value} key={list[i].value}>{list[i].display}</option>)
		}

		let dropdown_right_margin = 20;
		let margin_top = (this.props.height - 100) / 2;
		if (margin_top < 0) margin_top = 0;
		let drop_down_left = (this.props.width - 165) / 2;
		if (drop_down_left < 0) drop_down_left = 0;

		return (
			<div style={{ height: this.props.height, width: this.props.width, textAlign: 'center' }} >
				<div style={{ paddingTop: margin_top, marginLeft: 'auto', marginRight: 'auto' }}>
					<span className={'normal'} style={{ color: this.props.colours.font_header }}>{this.props.receiver.getString('sel_lang')}</span>
					<div style={{ padding: 10, maxHeight: 140, marginBottom: 20 }}>
						<Select
							style={{ display: 'inline-block', width: 'auto' }}
							select_style={{ fontSize: 16, height: 'auto', padding: 20, borderRadius: 20 }}
							options={languages}
							value={this.state.lang}
							onSelect={this.handleChangeLanguage}
						/>
					</div>
				</div>
				<div style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
					<Button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '90%', color: this.props.colours.button_font, padding: 20, borderRadius: 20, margin: 0, marginRight: 'auto', marginLeft: 'auto', textAlign: 'center' }} bgColor={this.props.colours.button_bg} onClick={this.handleNext}>{this.props.receiver.getString('get_started')}</Button>
				</div>
			</div>
		)
	}
}


